import moment from 'moment'
import { TaxDocumentationTaxIdType } from '../Types/backendTypes'
export type Env = 'local' | 'staging' | 'prod'

export const getEnv = (): Env => {
  if (window.location.host.includes('localhost')) return 'local'
  if (window.location.host.includes('staging.taxbit.com')) return 'staging'
  if (window.location.host.includes('.enterprise.taxbit.com')) return 'prod'
  return 'staging'
}

//check below can be removed once CAS deploys the custom domain for enterprise api
export const isUMC =
  window.location.host.includes('paypal') ||
  window.location.host.includes('zerohash') ||
  window.location.host.includes('uphold') ||
  window.location.host.includes('primetrust') ||
  window.location.host.includes('ftx') ||
  window.location.host.includes('demo') ||
  window.location.host.includes('paxos') ||
  window.location.host.includes('nydig') ||
  window.location.host.includes('localhost')

//TODO: We should investigate having this be a variable that is passed in
export const getAuthIssuerFromEnv = () => {
  const env = getEnv()
  switch (env) {
    case 'prod':
      return 'https://taxbit-ent.okta.com/oauth2/aus1n2v5e24w6v0zY696'
    case 'local':
    case 'staging':
    default:
      return 'https://taxbit-ent.oktapreview.com/oauth2/aus14ptn0sgNutzyC1d7'
  }
}

export const getAuthProviderConfigFromEnv = () => {
  const env = getEnv()

  const config = {
    /* use local env vals initially */
    oidc: {
      clientId: '0oa14ptgfhhtbLZHu1d7',
      issuer: 'https://taxbit-ent.oktapreview.com/oauth2/aus14ptn0sgNutzyC1d7',
      redirectUri: window.location.origin + '/login/callback',
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
      disableHttpsCheck: false,
    },
  }

  switch (env) {
    case 'local':
      config.oidc.issuer =
        'https://taxbit-ent.oktapreview.com/oauth2/aus14ptn0sgNutzyC1d7'
      config.oidc.clientId = '0oa14ptgfhhtbLZHu1d7'
      break
    case 'staging':
      config.oidc.issuer =
        'https://taxbit-ent.oktapreview.com/oauth2/aus14ptn0sgNutzyC1d7'
      config.oidc.clientId = '0oa14ptgfhhtbLZHu1d7'
      break
    case 'prod':
      config.oidc.issuer =
        'https://taxbit-ent.okta.com/oauth2/aus1n2v5e24w6v0zY696'
      config.oidc.clientId = '0oa1n0yepseYyKAoE696'
      break

    default:
      break
  }
  return config
}

export const getApiFromEnv = () => {
  const processEnvApi = process.env.REACT_APP_ENTERPRISE_API_URL
  if (processEnvApi) {
    return processEnvApi
  }

  const env = getEnv()
  if (isUMC) {
    switch (env) {
      case 'prod':
        return `https://ent-api.${window.location.hostname}/prod/api`
      case 'local':
        return 'https://developers.enterprise-staging.taxbit.com/api'
      case 'staging':
      default:
        return `https://ent-api.${window.location.hostname}/staging/api`
    }
  }
  return `${window.origin}/api`
}

export const getLaunchDarklyConfigFromEnv = () => {
  const env = getEnv()
  const config = {
    clientSideID: '',
  }
  switch (env) {
    case 'local':
    case 'staging':
      config.clientSideID = '610c2cd25fa16625b8cc100d'
      break
    default:
      config.clientSideID = '610c2cd25fa16625b8cc100e'
  }
  return config
}

export const dateFormatter = (d: string, opts?: Intl.DateTimeFormatOptions) =>
  new Date(d).toLocaleDateString(undefined, opts)

export const dateTimeFormatter = (date: string) =>
  new Date(date).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  })

export const getFullName = (firstName = 'Customer Name', lastName = '') => {
  return `${firstName} ${lastName}`
}

export const formatFiat = (quantity: number) => {
  return Math.abs(quantity)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d).)/g, ',')
}

export const formatAsset = (quantity: number) => {
  return Math.abs(quantity)
    .toFixed(8)
    .replace(/\B(?=(\d{3})+(?!\d).)/g, ',')
}

export const formatNumber = (num: number) => new Intl.NumberFormat().format(num)

export const sortAssetsByQuantity = (assets: any[]) => {
  return assets.sort(
    (
      assetA: { total_qty: { quantity: number } },
      assetB: { total_qty: { quantity: number } }
    ) => assetB.total_qty.quantity - assetA.total_qty.quantity
  )
}

export const getDefaultDates = (startMonth = 1) => {
  const startDateMS = moment()
    .utc()
    .subtract(startMonth, 'month')
    .startOf('month')
  const millisecondRE = /\.[0-9]{3}/
  const startDate = startDateMS.toISOString().replace(millisecondRE, '')
  const endDateMS = moment().utc().subtract(startMonth, 'month').endOf('month')
  const endDate = endDateMS.toISOString().replace(millisecondRE, '')
  return { startDate, endDate }
}

export const remaskTaxId = (
  taxId: string,
  taxIdType: TaxDocumentationTaxIdType | undefined
): string => {
  switch (taxIdType) {
    case TaxDocumentationTaxIdType.EIN:
      return `**-***${taxId.slice(-4)}`
    case TaxDocumentationTaxIdType.SSN:
    case TaxDocumentationTaxIdType.ITN:
      return `***-**-${taxId.slice(-4)}`
    default:
      return `*******${taxId.slice(-2)}`
  }
}

export const navigateToUrl = (url: string) => window.location.assign(url)

export const isString = (o: any): boolean =>
  typeof o === typeof 'string' || o instanceof String
